export default __webpack_public_path__ + "static/RootSans-5Regular-dad46e10a76f0f03c9bc744cf3c487f9.woff";